import api from '@/api'

const state = {
  formParam: {
    companyId: undefined,
    verifyType: 1 // 1：待验证 2：验证中
  }
}

const mutations = {
  setFormParam (state, data) {
    state.formParam = data
  },
  setFormParam_verifyType (state, number) {
    state.formParam.verifyType = number
  }
}

const actions = {
  // 改变form param
  changeFormParam ({ commit }, data) {
    commit('setFormParam', data)
  },
  // 改变form param verifyType
  changeFormParam_verifyType ({ commit }, n) {
    commit('setFormParam_verifyType', n)
  },
  mapListDistributionOrderNew ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListDistributionOrderNew(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/dsmpSupDistribution/mapListDistributionOrderNew', error: resData.error })
          }
        }
      }).catch(e => {
        reject({from: '/sweb/dsmpSupDistribution/mapListDistributionOrderNew', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  mapListDistributionOrderVerifying ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListDistributionOrderVerifying(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/dsmpSupDistribution/mapListDistributionOrderVerifying', error: resData.error })
          }
        }
      }).catch(e => {
        reject({ from: '/sweb/dsmpSupDistribution/mapListDistributionOrderVerifying', error: { code: 0, msg: '网络异常，请稍后再试' } })
      })
    })
  },
  getDsmpOrderCompanyList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getDsmpOrderCompanyList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/dsmpSupDistribution/getDsmpOrderCompanyList', error: resData.error })
          }
        }
      }).catch(e => {
        reject({ from: '/sweb/dsmpSupDistribution/getDsmpOrderCompanyList', error: { code: 0, msg: '网络异常，请稍后再试' } })
      })
    })
  },
  checkOmcVerifyCodeBatch ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.checkOmcVerifyCodeBatch(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/dsmpSupDistribution/checkOmcVerifyCodeBatch', error: resData.error })
          }
        }
      }).catch(e => {
        reject({ from: '/sweb/dsmpSupDistribution/checkOmcVerifyCodeBatch', error: { code: 0, msg: '网络异常，请稍后再试' } })
      })
    })
  },
  sendCompanySmsBatch ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.sendCompanySmsBatch(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/dsmpSupDistribution/sendCompanySmsBatch', error: resData.error })
          }
        }
      }).catch(e => {
        reject({ from: '/sweb/dsmpSupDistribution/sendCompanySmsBatch', error: { code: 0, msg: '网络异常，请稍后再试' } })
      })
    })
  },
  cancelVerifyCodeBatch ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.cancelVerifyCodeBatch(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/dsmpSupDistribution/cancelVerifyCodeBatch', error: resData.error })
          }
        }
      }).catch(e => {
        reject({ from: '/sweb/dsmpSupDistribution/cancelVerifyCodeBatch', error: { code: 0, msg: '网络异常，请稍后再试' } })
      })
    })
  },
  changeOmcOrderNew ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.changeOmcOrderNew(data).then(res => {
        let resData = res.data
        if (resData.ret === 1 && resData.data) {
          resolve(resData)
        } else {
          if (resData.error) {
            reject({ from: '/sweb/dsmpSupDistribution/changeOmcOrderNew', error: resData.error })
          }
        }
      }).catch(e => {
        reject({ from: '/sweb/dsmpSupDistribution/changeOmcOrderNew', error: { code: 0, msg: '网络异常，请稍后再试' } })
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/directOrder.js